import moment from 'moment'

function convertTableColumn(val) {
  return val ?? '--'
}

function convertDatetime(val) {
  if (!val) return null
  return moment(val).format('YYYY/MM/DD HH:mm:ss')
}

function convertOption(val, list) {
  return list.find((option) => option.value == val)?.label
}

function convertStringInsertSeporator(val, num, seporator) {
  if (!val) return null

  // console.log(val)
  let res = ''

  let n = parseInt(val.length / num, 10)
  for (let i = 0; i < n; i++) {
    res += val.substring(i * num, (i + 1) * num)
    if (i < n - 1) res += seporator
  }
  // console.log(res)

  return res
}

function convertEncryptCellphone(val) {
  if (!val) return null
  return '*******' + val.slice(-4)
}

function convertEncryptEmail(val) {
  if (!val) return null

  return (
    val.slice(0, Math.min(val.indexOf('@'), 4)) +
    '*******' +
    val.slice(val.indexOf('@'))
  )
}

function convertQueryDataDatetimeEnd(val) {
  if (!val) return null
  return moment(val).add(1, 's').subtract(8, 'h').format('YYYY-MM-DDTHH:mm:ss[Z]')
}

export default {
  convertTableColumn,
  convertDatetime,
  convertOption,
  convertStringInsertSeporator,
  convertEncryptCellphone,
  convertEncryptEmail,
  convertQueryDataDatetimeEnd,
}
